import axios from "axios";
import type {
    ForgotPasswordRequest,
    LoginRequest,
    MerchantLoginData,
    RefreshTokenData,
    ResetPasswordRequest,
} from "~/lib/api/types/auth";

const fetchRefreshTokenRetryLimit = 3;
let currentFetchRefreshTokenRetries = 0;

export async function forgotPassword(
    request: ForgotPasswordRequest,
): Promise<void> {
    await axios.post("auth/forgot-password", request);
}

export async function login(
    loginRequest: LoginRequest,
): Promise<MerchantLoginData> {
    const response = await axios.post<MerchantLoginData>(
        "/auth/login",
        loginRequest,
    );

    return response.data;
}

export async function refresh(
    token: string | undefined,
): Promise<RefreshTokenData> {
    try {
        const response = await axios.post<RefreshTokenData>("auth/refresh", {
            refresh_token: token,
        });
        currentFetchRefreshTokenRetries = 0;

        return response.data;
    } catch (error) {
        if (currentFetchRefreshTokenRetries < fetchRefreshTokenRetryLimit) {
            currentFetchRefreshTokenRetries += 1;

            return refresh(token);
        }

        throw error;
    }
}

export async function resetPassword(
    request: ResetPasswordRequest,
): Promise<void> {
    await axios.post("auth/reset-password", request);
}
